<template>
  <div
    :ref="generateSafeId(fieldQuestionId, 'wrapper')"
    class="RMPE-DynamicField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <component
      :is="layout.type"
      :image="layout.image"
      :video="layout.video"
    >
      <div class="field">
        <div class="control">
          <label
            class="label RMPE-DynamicField-Label"
            :for="fieldQuestionId"
          >
            <span
              :class="{'RMPE-Required': question.required}"
              v-html="question.formattedLabel"
            />
          </label>

          <HintMessage :hint="question.formattedDescription" />

          <MediaMiddlePartial :layout="layout" />
          <div class="input-container">
            <textarea
              :id="fieldQuestionId"
              ref="auto-focus-target"
              :value="fieldValue"
              :class="{ 'is-danger': fieldHasError }"
              type="text"
              class="input"
              autocomplete="no"
              @change="$emit('change', $event.target.value)"
              @keydown.enter="submitWithEnter"
            />
          </div>
        </div>
        <ErrorMessage
          :field-has-error="fieldHasError"
          :errors="error.errors"
          :is-blurred="isBlurred"
        />
        <div
          v-if="!fieldHasError && !isTouchDevice"
          class="RMPE-DynamicField-TextAreaHint"
        >
          <span>Shift <kbd>⇧</kbd></span> + <span class="is-family-code has-text-weight-bold ">Enter</span> <kbd>↵</kbd> to make a line break
        </div>
        <div class="RMPE-DynamicForm-SubmitContainer">
          <button
            :disabled="isNextButtonDisabled"
            class="button is-primary RMPE-CustomSubmit"
            @click="goToNextQuestion"
          >
            {{ question.goToNextQuestionButtonLabel }}
          </button>
          <span
            v-if="!isTouchDevice"
            class="RMPE-CustomSubmit-Hint"
          >
            press <span class="is-family-code has-text-weight-bold ">Enter</span> <kbd>↵</kbd>
          </span>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import DynamicFieldMixin from '../../mixins/dynamic-field-mixin';
import TextareaFieldMixin from '../common/textarea-field';

export default {
  mixins: [DynamicFieldMixin, TextareaFieldMixin],

  methods: {
    submitWithEnter(event) {
      if (this.isTouchDevice) {
        return;
      }
      // console.log(event);

      if (event.shiftKey === true) return;

      this.$emit('change', event.target.value);

      this.goToNextQuestion();
    },
  },
};
</script>

<style scoped lang="scss">
textarea {
  min-height: 150px;
}
.RMPE-DynamicForm-SubmitContainer {
  transform: translateY(-0px);
}
</style>
